import React from 'react';
import classNames from 'classnames';

const CartIconBlack = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 38 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.41667 6.75H35.3333L32.1667 21H11.5833M11.5833 21L6.83333 2H0.5M11.5833 21L13.1667 27.3333H33.75M30.5833 35.25C30.1634 35.25 29.7607 35.0832 29.4637 34.7863C29.1668 34.4893 29 34.0866 29 33.6667C29 33.2467 29.1668 32.844 29.4637 32.5471C29.7607 32.2501 30.1634 32.0833 30.5833 32.0833C31.0033 32.0833 31.406 32.2501 31.7029 32.5471C31.9999 32.844 32.1667 33.2467 32.1667 33.6667C32.1667 34.0866 31.9999 34.4893 31.7029 34.7863C31.406 35.0832 31.0033 35.25 30.5833 35.25ZM14.75 35.25C14.3301 35.25 13.9273 35.0832 13.6304 34.7863C13.3335 34.4893 13.1667 34.0866 13.1667 33.6667C13.1667 33.2467 13.3335 32.844 13.6304 32.5471C13.9273 32.2501 14.3301 32.0833 14.75 32.0833C15.1699 32.0833 15.5727 32.2501 15.8696 32.5471C16.1665 32.844 16.3333 33.2467 16.3333 33.6667C16.3333 34.0866 16.1665 34.4893 15.8696 34.7863C15.5727 35.0832 15.1699 35.25 14.75 35.25Z"
      stroke="currentColor"
      strokeWidth="3"
    />
  </svg>
);

const CartIconWhite = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.91667 6.75H34.8333L31.6667 21H11.0833M11.0833 21L6.33333 2H0M11.0833 21L12.6667 27.3333H33.25M30.0833 35.25C29.6634 35.25 29.2607 35.0832 28.9637 34.7863C28.6668 34.4893 28.5 34.0866 28.5 33.6667C28.5 33.2467 28.6668 32.844 28.9637 32.5471C29.2607 32.2501 29.6634 32.0833 30.0833 32.0833C30.5033 32.0833 30.906 32.2501 31.2029 32.5471C31.4999 32.844 31.6667 33.2467 31.6667 33.6667C31.6667 34.0866 31.4999 34.4893 31.2029 34.7863C30.906 35.0832 30.5033 35.25 30.0833 35.25ZM14.25 35.25C13.8301 35.25 13.4273 35.0832 13.1304 34.7863C12.8335 34.4893 12.6667 34.0866 12.6667 33.6667C12.6667 33.2467 12.8335 32.844 13.1304 32.5471C13.4273 32.2501 13.8301 32.0833 14.25 32.0833C14.6699 32.0833 15.0727 32.2501 15.3696 32.5471C15.6665 32.844 15.8333 33.2467 15.8333 33.6667C15.8333 34.0866 15.6665 34.4893 15.3696 34.7863C15.0727 35.0832 14.6699 35.25 14.25 35.25Z"
      stroke="currentColor"
      strokeWidth="3"
    />
  </svg>
);

const CartFullIconBlack = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.91667 13.75H34.8333L31.6667 28H11.0833M11.0833 28L6.33333 9H0M11.0833 28L12.6667 34.3333H33.25M30.0833 42.25C29.6634 42.25 29.2607 42.0832 28.9637 41.7863C28.6668 41.4893 28.5 41.0866 28.5 40.6667C28.5 40.2467 28.6668 39.844 28.9637 39.5471C29.2607 39.2501 29.6634 39.0833 30.0833 39.0833C30.5033 39.0833 30.906 39.2501 31.2029 39.5471C31.4999 39.844 31.6667 40.2467 31.6667 40.6667C31.6667 41.0866 31.4999 41.4893 31.2029 41.7863C30.906 42.0832 30.5033 42.25 30.0833 42.25ZM14.25 42.25C13.8301 42.25 13.4273 42.0832 13.1304 41.7863C12.8335 41.4893 12.6667 41.0866 12.6667 40.6667C12.6667 40.2467 12.8335 39.844 13.1304 39.5471C13.4273 39.2501 13.8301 39.0833 14.25 39.0833C14.6699 39.0833 15.0727 39.2501 15.3696 39.5471C15.6665 39.844 15.8333 40.2467 15.8333 40.6667C15.8333 41.0866 15.6665 41.4893 15.3696 41.7863C15.0727 42.0832 14.6699 42.25 14.25 42.25Z"
      stroke="currentColor"
      strokeWidth="3"
    />
    <circle
      cx="34.5"
      cy="9.5"
      r="8.75"
      fill="url(#paint0_linear_cart_full_black)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_cart_full_black"
        x1="34.5"
        y1="0"
        x2="34.5"
        y2="17"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D64718" />
        <stop offset="0.4" stopColor="#B3667E" />
        <stop offset="1" stopColor="#8875D5" />
      </linearGradient>
    </defs>
  </svg>
);

const CartFullIconWhite = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.91667 13.75H34.8333L31.6667 28H11.0833M11.0833 28L6.33333 9H0M11.0833 28L12.6667 34.3333H33.25M30.0833 42.25C29.6634 42.25 29.2607 42.0832 28.9637 41.7863C28.6668 41.4893 28.5 41.0866 28.5 40.6667C28.5 40.2467 28.6668 39.844 28.9637 39.5471C29.2607 39.2501 29.6634 39.0833 30.0833 39.0833C30.5033 39.0833 30.906 39.2501 31.2029 39.5471C31.4999 39.844 31.6667 40.2467 31.6667 40.6667C31.6667 41.0866 31.4999 41.4893 31.2029 41.7863C30.906 42.0832 30.5033 42.25 30.0833 42.25ZM14.25 42.25C13.8301 42.25 13.4273 42.0832 13.1304 41.7863C12.8335 41.4893 12.6667 41.0866 12.6667 40.6667C12.6667 40.2467 12.8335 39.844 13.1304 39.5471C13.4273 39.2501 13.8301 39.0833 14.25 39.0833C14.6699 39.0833 15.0727 39.2501 15.3696 39.5471C15.6665 39.844 15.8333 40.2467 15.8333 40.6667C15.8333 41.0866 15.6665 41.4893 15.3696 41.7863C15.0727 42.0832 14.6699 42.25 14.25 42.25Z"
      stroke="currentColor"
      strokeWidth="3"
    />
    <circle
      cx="34.5"
      cy="9.5"
      r="8.75"
      fill="url(#paint0_linear_cart_full_white)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_cart_full_white"
        x1="34.5"
        y1="0"
        x2="34.5"
        y2="17"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D64718" />
        <stop offset="0.4" stopColor="#B3667E" />
        <stop offset="1" stopColor="#8875D5" />
      </linearGradient>
    </defs>
  </svg>
);

interface CartIconProps {
  isBackgroundWhite: boolean;
  hasItems: boolean;
  onClick: () => void;
}

export default function CartIcon({
  hasItems,
  isBackgroundWhite,
  onClick,
}: CartIconProps): React.ReactElement {
  const IconComponent: ({
    className,
  }: {
    className?: string;
  }) => React.ReactElement = hasItems
    ? isBackgroundWhite
      ? CartFullIconBlack
      : CartFullIconWhite
    : isBackgroundWhite
      ? CartIconBlack
      : CartIconWhite;

  return (
    <button
      type="button"
      aria-label={hasItems ? 'Open cart with items' : 'Open cart'}
      onClick={onClick}
      className="group cursor-pointer appearance-none border-0 bg-transparent p-0"
    >
      <div className="relative transition-all duration-300 ease-in-out group-hover:scale-110">
        <div className="absolute inset-0 scale-150 transform rounded-full bg-linear-to-t from-[#D64718] to-[#E98C6C] opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-20"></div>
        <IconComponent
          className={classNames(
            'relative z-10 transition-colors duration-300 ease-in-out',
            isBackgroundWhite
              ? 'text-black group-hover:text-[#8875D5]'
              : 'text-white group-hover:text-[#C3B5FF]'
          )}
        />
      </div>
    </button>
  );
}
